/* eslint-disable react/jsx-no-bind */
import React, {useEffect, useState} from "react";
import EventsAPI from "../../../shared/modules/EventsAPI";
import FaqQuestionAnswer from "./FaqQuestionAnswer";
import PlusMinusButton from "./PlusMinusButton";
import PropTypes from "prop-types";

const FaqQuestion = ({
  answerContent,
  index,
  questionContent
}) => {
  const [
    expanded,
    setExpanded
  ] = useState(false);

  const handleClick = () => setExpanded(expandedValue => !expandedValue);

  useEffect(() => {
    const eventName = "clicked_faq";
    if (expanded) EventsAPI.trackCustomerEvent(eventName, questionContent);
  }, [expanded]);

  const getQuestionClassNames = () => (
    expanded ? "faq-question underline small faq-bar" : "faq-question small faq-bar"
  );

  const getRowClassNames = () => (
    index % 2 === 0 ? "color-light-grey-bg faq-bar" : "faq-bar"
  );

  return (
    <div className={getRowClassNames()} >
      <div
        className={getQuestionClassNames()}
        onClick={handleClick}
      >
        {questionContent}
        <PlusMinusButton expanded={expanded} />
      </div>
      {expanded && <FaqQuestionAnswer answerContent={answerContent} />}
    </div>
  );
};

FaqQuestion.propTypes = {
  "answerContent": PropTypes.arrayOf(String).isRequired,
  "index": PropTypes.number.isRequired,
  "questionContent": PropTypes.string.isRequired
};

export default FaqQuestion;
